import { usePermissionsContext } from "../PermissionsContext";
import { PERMISSIONS } from "../utils/permissions";
import { userService } from "../../../services/user.service";

/** Roles that never see the system prices, whatever their permissions */
const ROLES_WITHOUT_PRICES = ["INVENTORY_MANAGER"];

export const usePermission = () => {

  const { authorities } = usePermissionsContext();

  // a list of permissions means any of them
  const can = (permission) => {
    if (Array.isArray(permission)) return permission.some(can);
    if (permission === 'system.verifiche') return true; // TEMPORARY BYPASS
    return authorities.includes(permission);
  };

  // the system prices (total, ordered value, face prices, price filter and trend)
  const canSeePrices = () => can(PERMISSIONS.SYSTEM_PRICE_READ) && !ROLES_WITHOUT_PRICES.includes(userService.getLocalUserRole());

  // the role of the user in the Alessi tenant, e.g. hasRole("INVENTORY_MANAGER")
  const hasRole = (role) => userService.getLocalUserRole() === role;

  // a page or menu item limited to some roles (none = every role)
  const canOpen = (permission, roles) => can(permission) && (!roles?.length || roles.some(hasRole));

  return { can, canSeePrices, hasRole, canOpen };

};
